module.exports = __webpack_public_path__ + "static/media/confirm.00ff4516.svg";